import React from 'react';

import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

interface RetryFailedSaveToResultsStepBannerProps {
  /**
   * If defined, an action to Reconfigure mapping will be shown.
   * If undefined, the action will not be shown.
   */
  openReconfigurationView?: () => void;
  text?: string;
  supportingInfo?: string;
}

export default function RetryFailedSaveToResultsStepBanner(
  props: RetryFailedSaveToResultsStepBannerProps
): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.ERROR}
      text={props.text ?? 'Error saving to results'}
      supportingInfo={props.supportingInfo}
      action={
        props.openReconfigurationView
          ? {
              actionType: InlineBannerActionType.CUSTOM,
              actionText: 'Reconfigure mapping',
              actionOnClick: props.openReconfigurationView,
            }
          : undefined
      }
    />
  );
}
